import axios from 'axios';
import api from './api';

const authURL = process.env.REACT_APP_ISTANBUL_URL + "/auth"

export const loginAPI = (idToken: string) => {
    
    const headers = {
        'Authorization': `Bearer ${idToken}`,
        'APP-KEY': process.env.REACT_APP_APP_KEY
    }

    axios.defaults.baseURL = authURL
    return axios.post("/login", {}, {headers})
}

export const applicationLoginAPI = (profile: string) => {
    const headers = {
        'APP-KEY': process.env.REACT_APP_APP_KEY
    }

    return api.post(`${authURL}/application-login`, {profile}, {headers})
}